"use client";
import React, { createContext, useContext, useState } from 'react';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, duration = 2500) => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, visible: true }]);

    setTimeout(() => {
      setToasts((prev) => prev.map((t) =>
        t.id === id ? { ...t, visible: false } : t
      ));
      // Clean up after fade-out
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 300);
    }, duration);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};